<div
  id="iris-modal"
  role="dialog"
  aria-labelledby="iris-modal-title"
  aria-modal="true"
  tabindex="0"
  data-test="iris-modal"
>
  <header class="iris-modal-header">
    <h1
      id="iris-modal-title"
      class="iris-modal-title"
      data-test="connect-modal-title"
    >
      {{ title }}
    </h1>
  
    <iris-icon-button
      (click)="close()"
      class="iris-modal-close"
      icon="close"
      [type]="irisIconButtonTypes.TERTIARY"
      ariaLabel="close"
    ></iris-icon-button>
  </header>
  
  <main class="iris-modal-content" data-test="connect-modal-content">
    <ng-container *ngIf="contentType === contentTypeEnum.TEMPLATE">
    <ng-container *ngTemplateOutlet="contentTemplate; context: $any(context)"></ng-container>
    </ng-container>
  
    <ng-container *ngIf="contentType === contentTypeEnum.COMPONENT">
      <ng-container *ngComponentOutlet="contentComponent"></ng-container>
    </ng-container>
  </main>
</div>
